export class BefreiungAnfrage {
    KvNummer: string;
    Einwilligung: string;
  
    constructor(kvNummer?: string, einwilligung?: string) {
        if (kvNummer) {
          this.KvNummer = kvNummer;
        }
        if (einwilligung) {
          this.Einwilligung = einwilligung;
        }
    }
  }
  
  


// WEBPACK FOOTER //
// ./src/app/befreiung/shared/entities/befreiungAnfrage.ts